import { deleteApiGalaxyServer } from 'services';

export interface DeleteSuppressedEmailParams {
  email: string;
}

export interface DeleteSuppressedEmailResponse {
  removed: boolean;
}

export const deleteSuppressedEmailApi = ({
  params,
  token,
  config,
}: BaseApiParams<DeleteSuppressedEmailParams>) =>
  deleteApiGalaxyServer<Record<string, never>, DeleteSuppressedEmailResponse>(
    '/aws/suppressedEmails',
    {},
    {
      ...config,
      params: { email: params.email },
    },
    token,
  );
